/* eslint-disable @typescript-eslint/no-explicit-any */

import { ChartData, ChartOptions } from "chart.js";

function configs(labels: string[], datasets: any[]) {
  const data: ChartData<"line"> = {
    labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      tension: dataset.tension || 0,
      pointRadius: dataset.pointRadius || 3,
      borderWidth: dataset.borderWidth || 4,

      fill: dataset.fill !== undefined ? dataset.fill : true,
      pointBackgroundColor: dataset.pointBackgroundColor || dataset.borderColor,
      borderColor: dataset.borderColor,
      maxBarThickness: dataset.maxBarThickness || 6,
    })),
  };

  const options: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    scales: {
      y: {
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: false,
          color: "#c1c4ce5c",
        },
        ticks: {
          display: true,
          padding: 10,
          color: "#9ca2b7",
          font: {
            size: 14,

            style: "normal",
            lineHeight: 2,
          },
        },
      },
      x: {
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: true,
          color: "#c1c4ce5c",
        },
        ticks: {
          display: true,
          color: "#9ca2b7",
          padding: 10,
          font: {
            size: 14,

            style: "normal",
            lineHeight: 2,
          },
        },
      },
    },
  };

  return { data, options };
}

export default configs;
